import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Popover from '@mui/material/Popover'
import Button from '@mui/material/Button'

const HeaderMenuItem = (props) => {
  const { label, elementId, navigation, submenu, setForceClosePopover, handleClosePopoverFromParent } = props
  const theme = useTheme()
  const navigate = useNavigate()

  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const buttonStyle = {
    textTransform: 'none',
    fontWeight: '400',
    color: theme.palette.oxfordBlue,
    fontSize: '22px',

    '&:hover': {
      background: 'inherit',
      color: theme.palette.violetsAreBlue,
    },
  }

  const handleClick = (event) => {
    const element = elementId ? document.getElementById(elementId) : null
    
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }

    if (navigation) {
      navigate(navigation)
      if (handleClosePopoverFromParent) {
        handleClosePopoverFromParent()
      }
    }

    if (submenu && submenu.length > 0) {
      handleOpenPopover(event)
    } else if (setForceClosePopover) {
      setForceClosePopover(true)
    }
  }

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        variant='text'
        disableRipple
        disableElevation
        sx={buttonStyle}
        onClick={handleClick}
      >
        {label}
      </Button>
      {
        (submenu && submenu.length > 0) &&
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <Box sx={{ padding: '20px' }}>
            <Stack
              direction='column'
              alignItems='flex-start'
              justifyContent='flex-start'
              spacing={2}
              sx={{ width: '100%' }}
            >
              {
                submenu.map((item, index) => (
                  <HeaderMenuItem
                    key={index}
                    {...item}
                    handleClosePopoverFromParent={handleClosePopover}
                    setForceClosePopover={setForceClosePopover}
                  />
                ))
              }
            </Stack>
          </Box>        
        </Popover>
      }      
    </>
    
  )
}

export default HeaderMenuItem